'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _drawerIcon = require('./drawer-icon');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_drawerIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }